export default "__VITE_ASSET__BSXO_fSC__"